








































































import { Agent } from '@/models/agent';
import { Region } from '@/models/region';
import Vue from 'vue';
import { mapActions } from 'vuex';
import { get } from 'vuex-pathify';

import ALPage from '@/components/core/Page/ALPage.vue';

export default Vue.extend({
  name: 'AgentListPage',

  components: { ALPage },

  data() {
    return {
      loading: true,
      search: '',
      agentHeaders: [
        { text: 'ID', value: 'code', width: 100 },
        { text: 'Name', value: 'name' },
        { text: 'Region', value: 'region' },
        { text: '', align: 'center', value: 'actions', width: 120 }
      ]
    };
  },

  computed: {
    agents: get<Agent>('agent/agents'),
    getRegionById: get<(id: number) => Region>('region/getRegionById')
  },

  mounted() {
    this.getAgents();
    this.fetchRegions();
  },
  methods: {
    ...mapActions({
      fetchAgents: 'agent/fetchAgents',
      deleteAgent: 'agent/deleteAgent',
      fetchRegions: 'region/fetchRegions'
    }),

    openAgentDialog(agent?: Agent) {
      const dialog = (this as any).$refs.agentFormDialog;
      dialog.open(agent);
    },

    async destroyAgent(agent: Agent) {
      const confirm = (this as any).$refs.confirm;
      if (
        await confirm.open(
          'Delete Agent',
          {},
          `<span style="line-height: 19px;">Are you sure you want to delete <strong class="text--primary" style="word-break: normal">${agent.name}</strong>? <br /> This action cannot be undone.</span>`
        )
      ) {
        await this.deleteAgent(agent.id);
      }
    },

    getAgents() {
      this.loading = true;

      return this.fetchAgents().finally(() => {
        this.loading = false;
      });
    }
  }
});
